var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{staticClass:"d-inline-flex p-3"},[_c('button',{staticClass:"btn btn-tertiary",attrs:{"type":"button"},on:{"click":_vm.logout}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":"sign-out-alt","transform":"shrink-1"}}),_vm._v(" Logout ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }